// Copyright 2026. WebPros International GmbH. All rights reserved.

export const SET_LAST_USED_SSH_KEYS = 'last-used-ssh-keys-type/SET_LAST_USED_SSH_KEYS';
